const _ = require('../../utils/lodash').default;
export default {
    namespaced: true,
    state: {
        id: null,
        title: null,
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        accessToken: null,
        accessTokenExpiresAt: null,
        verified: null,
        code: null,
        direct_debit: true,
        pendingDeal: false,
        recommendationCode: null,
        worthlessDeal: false,
        balance: null,
        totalRewards: null,
        totalPayouts: null,
        fresh: false,
    },
    getters: {
        user: (state) => {
            return {
                id: state.id,
                first_name: state.first_name,
                last_name: state.last_name,
                email: state.email,
                phone: state.phone,
                verified: state.verified,
                direct_debit: state.direct_debit,
            };
        },
        isUser: (state) =>  !!state.id,

        isGuest: (state) =>  !state.id,

        isVerified: (state) =>  !!state.id && !!state.verified,

        hasDirectDebit: (state) =>  !!state.id && !!state.direct_debit,

        getUserId: (state) =>  state.id,

        title: (state) =>  state.title,

        firstName: (state) =>  state.first_name,

        lastName: (state) =>  state.last_name,

        email: (state) =>  state.email,

        phone: (state) =>  state.phone,

        getAccessToken: (state) =>  state.accessToken,

        getAccessTokenExpiresAt: (state) =>  state.accessTokenExpiresAt,

        isAccessTokenExpired: (state) => {
            let ts = Math.round((new Date()).getTime() / 1000);
            return state.accessTokenExpiresAt < ts;
        },

        hasPendingDeal: (state) =>  !!state.recommendationCode,

        recommendationCode: (state) =>  state.recommendationCode,

        referralCode: (state) =>  state.code,

        totalRewards: (state) => state.totalRewards,

        totalPayouts: (state) => state.totalPayouts,

        totalBalance: (state) => (state.totalRewards || 0) - (state.totalPayouts || 0),

        balance: (state) =>  state.balance,

        isFresh: (state) => state.fresh,

        hasWorthlessDeal: (state) => state.worthlessDeal
    },
    mutations: {
        setId: (state, payload) => {
            if (!state.id) {
                state.id = payload;
            }
        },
        setUser: (state, payload) => {
            _.each(payload, function (v, k) {
                if(Object.keys(state).indexOf(k) >= 0){
                    state[k] = v;
                }
            });
        },
        clear: (state) => {
            _.each(state, function (v, k) {
                state[k] = null;
            });
        },
        setAccessToken: (state, payload) => state.accessToken = payload,

        setAccessTokenExpiresAt: (state, payload) => state.accessTokenExpiresAt = payload,

        setVerified: (state) => state.verified = true,

        setNotVerified: (state) => state.verified = false,

        setDirectDebit: (state, payload) => state.direct_debit = payload,

        setTitle: (state, payload) => state.title = payload,

        setFirstName: (state, payload) => state.first_name = payload,

        setLastName: (state, payload) => state.last_name = payload,

        email: (state, payload) => state.email = payload,

        phone: (state, payload) => state.phone = payload,

        recommendationCode: (state, payload) => state.recommendationCode = payload,

        setIsFresh: (state, payload) => state.fresh = payload,

        balance: (state, payload) => state.balance = payload,

        totalRewards: (state, payload) => state.totalRewards = payload,

        totalPayouts: (state, payload) => state.totalPayouts = payload,

        setWorthlessDeal: (state, payload) => state.worthlessDeal = payload
    }
}
